<p>
    {{reviewscore}} 
    <span [ngClass]="reviewscore>=0.5?'icon-starfull':'icon-star'"></span>
    <span [ngClass]="reviewscore>=1.5?'icon-starfull':'icon-star'"></span>
    <span [ngClass]="reviewscore>=2.5?'icon-starfull':'icon-star'"></span>
    <span [ngClass]="reviewscore>=3.5?'icon-starfull':'icon-star'"></span>
    <span [ngClass]="reviewscore>=4.5?'icon-starfull':'icon-star'"></span>
    {{reviewnumber||0}} Reviews
</p>